// extracted by mini-css-extract-plugin
export default {"list":"List_list__nnEOS","list__item":"List_list__item__TLbhZ","ul":"List_ul__9Bz7w","ol":"List_ol__LBsT8"};